export default __webpack_public_path__ + "static/media/upload.4ba62773.svg";